import React from 'react';
import {Box} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const Loading = () => (
  <Box
    display="flex"
    height="100vh"
    justifyContent="center"
    alignItems="center">
    <CircularProgress size={140} sx={{color: '#6BBFE9'}} />
  </Box>
);

export default Loading;
